import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { AccountingApi } from '_api';
import { MODAL_KEYS } from '_constants/modals';
import { handleError, handleResponse } from '_helpers/api';
import { createOAuthUrl } from '_helpers/oauth';
import { hideModal } from '_store/modals/slice';

export const getOAuthUrl = createAsyncThunk(
  'oauth/getOAuthUrl',
  async function ({ customerId, productId }, { dispatch, rejectWithValue }) {
    try {
      const response = await AccountingApi.getOAuthUrl({ customerId, productId });
      const result = handleResponse(response);
      const url = createOAuthUrl(result);

      dispatch(hideModal({ key: MODAL_KEYS.xeroAuthConfirm }));

      window.open(url, '_self');
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

export const authenticate = createAsyncThunk(
  'oauth/authenticate',
  async function ({ customerId, productId, code, state, redirectUrl }, { rejectWithValue }) {
    try {
      await AccountingApi.authenticate({ customerId, productId, code, state, redirectUrl });
    } catch (error) {
      const processedError = handleError(error);
      return rejectWithValue(processedError);
    }
  }
);

const oauthSlice = createSlice({
  name: 'oauth',
  initialState: {
    success: false,
    error: null,
    loading: false,
  },
  reducers: {
    resetError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getOAuthUrl.pending, (state) => {
        state.error = null;
        state.loading = true;
      })
      .addCase(getOAuthUrl.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getOAuthUrl.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });

    builder
      .addCase(authenticate.pending, (state) => {
        state.success = false;
        state.error = null;
        state.loading = true;
      })
      .addCase(authenticate.fulfilled, (state) => {
        state.success = true;
        state.loading = false;
      })
      .addCase(authenticate.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export const { resetError } = oauthSlice.actions;

export default oauthSlice.reducer;
